import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBuilding, FaUser } from 'react-icons/fa';
import './Auth.css';
import './RoleSelect.css';
import GuideWell_Blue from '../Assets/RSIDE.png';

function RoleSelect() {
  const navigate = useNavigate();
  const location = useLocation();
  const mode = new URLSearchParams(location.search).get('mode') || 'login';
  const isLogin = mode === 'login';

  return (
    <div className="auth-container auth-dark-bg">
      <div className="auth-card role-card auth-dark-card">
        <img src={GuideWell_Blue} alt="RSIDE" className="auth-GuideWell_Blue" />

        <h2 className="auth-title">
          {isLogin ? 'Welcome Back' : 'Create Your Account'}
        </h2>
        <p className="role-subtitle">
          {isLogin ? 'Who are you logging in as?' : 'Who are you signing up as?'}
        </p>

        <div className="role-options">
          <button
            className="role-option-btn"
            onClick={() => navigate(isLogin ? '/login' : '/signup')}
          >
            <div className="role-icon-wrap role-pm">
              <FaBuilding />
            </div>
            <div className="role-option-text">
              <span className="role-option-title">Property Manager</span>
              <span className="role-option-desc">Manage your properties, tenants & finances</span>
            </div>
            <span className="role-arrow">›</span>
          </button>

          <button className="role-option-btn" onClick={() => navigate(isLogin ? '/tenant/login' : '/tenant/signup')}>
            <div className="role-icon-wrap role-tenant">
              <FaUser />
            </div>
            <div className="role-option-text">
              <span className="role-option-title">Tenant</span>
              <span className="role-option-desc">View your lease, payments & property info</span>
            </div>
            <span className="role-arrow">›</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoleSelect;
